// src/features/feedback/labels.ts
import { t as uiText } from '../../i18n';
import type { FeedbackCategory, FeedbackStatus } from './types';

export function feedbackCategoryLabel(category: FeedbackCategory): string {
  switch (category) {
    case 'bug':
      return uiText("Bug report");
    case 'improvement':
      return uiText("Improvement request");
    case 'feature':
      return uiText("Feature request");
    case 'ux':
      return uiText("Usability");
    default:
      return uiText("Other");
  }
}

export function feedbackStatusLabel(status: FeedbackStatus): string {
  switch (status) {
    case 'open':
      return uiText("Not started");
    case 'inProgress':
      return uiText("In progress");
    default:
      return uiText("Done");
  }
}
